export default {
  componentName: 'ServicesPage',
  fr: {
    title:
      'Prise de rendez-vous à l’aide du répertoire des services offerts ordonnés dans des catégories.',
    services: {
      title: 'Répertoire des services',
      arrow: {
        goBackAriaLabel: 'Bouton lien. Cliquez pour retourner au répertoire des services.',
        goHomeAriaLabel: "Bouton lien. Cliquez pour retourner à l'accueil de Clic Santé."
      },
      ariaLabel:
        'Répertoire des services. Titre de la page. Les services sur Clic Santé sont regroupés en 32 catégories. La catégorie {0} est sélectionnée. '
    },
    subtitle: 'liste des services',
    subtitleCategories: 'liste des catégories',
    allServices: 'Tous les services',
    home: 'Accueil',
    back: 'Retour',
    filterBy: 'Filtrer par',
    meta: "Il est possible d'avoir accès à l'ensemble des services offerts sur la plateforme de prise de rendez-vous Clic Santé...",
    description:
      'Le registre des services donne accès à la liste complète des différents services offerts sur la plateforme Clic Santé. Il est plus simple de trouver le service que vous cherchez en partant de la page d’accueil. Il suffit de sélectionner une catégorie ou d’écrire dans la barre de recherche votre besoin.'
  },
  en: {
    title: 'Make an appointment using the directory of services offered sorted into categories.',
    services: {
      title: 'Service directory',
      arrow: {
        goBackAriaLabel: 'Link button. Click to return to the services directory.',
        goHomeAriaLabel: 'Link button. Click to return to Clic Santé home page.'
      },
      ariaLabel:
        'Service directory. Page title. Clic Santé services are grouped into 32 categories. The {0} category is selected. '
    },
    subtitle: 'list of services',
    subtitleCategories: 'list of categories',
    allServices: 'All the services',
    home: 'Home',
    back: 'Back',
    filterBy: 'Filter by',
    meta: 'You can access all the services offered on the Clic Sante platform...',
    description:
      "The services register contains the full list of services offered on the Clic Santé platform. It's easier to find what you're looking for from the home page. Select a category or enter your needs in the search bar."
  }
}
